import React, { useState, useEffect } from "react";
import "./Home.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";
import LoginModal from "../../components/LoginModal";
import RegistrationModal from "../../components/RegistrationModal";
import { postApi } from "../../services/api/api";
const Home = () => {
  const navigate = useNavigate();
    const [teamMembers, setTeamMembers] = useState([]);
    const [loadingTeam, setLoadingTeam] = useState(false);
  var homeBanner = {
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false
  };

  const testimonial_slider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // below 1024px screen width
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // below 768px screen width
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // below 480px screen width
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

   const ourStories_slider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // below 1024px screen width
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // below 768px screen width
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // below 480px screen width
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
      const fetchHomeTeam = async () => {
          setLoadingTeam(true);
          try {
              const response = await postApi("/team-list", {
                  skip: 0,
                  take: 4, // Directly querying 4 items to save overhead response bandwidth
                  search: ""
              });

              if (Array.isArray(response?.data)) {
                  // Slice runtime evaluation backup just in case API structure variations return full lists
                  setTeamMembers(response.data.slice(0, 4));
              }
          } catch (err) {
              console.error("Error fetching home team data:", err);
          } finally {
              setLoadingTeam(false);
          }
      };

      fetchHomeTeam();
  }, []);
  return (
    <>
      

      {/* intro section */}
      <section className="h-about-us pt-3">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <img
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="500"
                className="about-img"
                src={`${process.env.PUBLIC_URL}/assets/imgs/intro_img.png`}
              ></img>
            </div>
            <div
              className="col-md-6 about_right-content"
              data-aos="fade-up"
              data-aos-easing="ease-in-out"
              data-aos-duration="700"
            >
              <div className="section-heading">
                <h1 className="headingtxt">
                  Welcome to <br></br>
                  <span>Vikas Mandal Mulund</span>
                </h1>
              </div>
              <div className="txt-content">
                <p>
                  Where timeless traditions meet modern connections. Our Marathi
                  matrimonial platform is a harmonious blend of cultural
                  richness and contemporary matchmaking, dedicated to fostering
                  enduring relationships within the vibrant Marathi community.
                  Explore a world of possibilities as we celebrate the beauty of
                  love, commitment, and shared values
                </p>
              </div>
              <div className="cont_d_cont">
                <div className="cont_d me-3">
                  <img
                    className="icon_img"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/phone_icon.png`}
                  ></img>

                  <div className="cont_info">
                    <p>Enquiry</p>
                    <a style={{textDecoration:'none'}}  href="tel:+917021057077"><h5>+91 70210 57077</h5></a>
                  </div>
                </div>
                <div className="cont_d">
                  <img
                    className="icon_img"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/mail_icon.png`}
                  ></img>

                  <div className="cont_info">
                    <p>Get Support</p>
                    <a style={{textDecoration:'none'}} href="mailto:support@vikasmandalmulund.com"><h5>support@vikasmandalmulund.com</h5></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* bannner section */}
      <Slider className="home-banner" {...homeBanner}>
        <div className="banner-img">
          <img src={`${process.env.PUBLIC_URL}/assets/imgs/banner_img.png`} alt="Banner_1" />

          <div className="banner-content">
            <h1 className="font-medium">
              Start Your Beautiful Journey of Love, <br></br>Trust, and
              Companionship
            </h1>
            <p>
              Discover meaningful connections with people who share your values
              and dreams.
            </p>

            <div className="d-flex mt-4">
              <a className="btn banner_btn me-3" data-bs-toggle="modal" data-bs-target="#registrationModal">
                Register Now
              </a>
              <a className="btn banner_btn" data-bs-toggle="modal" data-bs-target="#loginModal">
                Login
              </a>
            </div>
          </div>
        </div>
      </Slider>

      {/* section count */}
      <section className="ab-cont">
        <div className="container-fluid">
          <div className="row">
            <ul>
              <li
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="500"
              >
                <div className="ab-cont-po">
                  <i className="fa fa-heart" aria-hidden="true"></i>
                  <div>
                    <h4>2K</h4>
                    <span>Couples paired</span>
                  </div>
                </div>
              </li>
              <li
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="700"
              >
                <div className="ab-cont-po">
                  <i className="fa fa-users" aria-hidden="true"></i>
                  <div>
                    <h4>4000+</h4>
                    <span>Registrants</span>
                  </div>
                </div>
              </li>
              <li
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="900"
              >
                <div className="ab-cont-po">
                  <i className="fa fa-male" aria-hidden="true"></i>
                  <div>
                    <h4>1600+</h4>
                    <span>Mens</span>
                  </div>
                </div>
              </li>
              <li
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="1100"
              >
                <div className="ab-cont-po">
                  <i className="fa fa-female" aria-hidden="true"></i>
                  <div>
                    <h4>2000+</h4>
                    <span>Womens</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
{/* get suchi section */}

<section className="">
  <div className="container suchi_section" data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="500">
    <div className="row">
        <div className="col-md-4 ps-0">
            <div className="l_img">
                 <img src={`${process.env.PUBLIC_URL}/assets/imgs/suchi_img.png`} alt="Banner 1" />
            </div>
        </div>
        <div className="col-md-8">
            <div className="r_content">
                <div className="section-heading">
                    <h1 className="headingtxt">
                        VMM Suchi
                        <br></br>
                        Discover Your Perfect Match
                    </h1>
                </div>
                <div className="txt-content">
                    <p>
                        Find your perfect life partner with VMM Suchi, the ultimate matrimonial solution! Our exclusive
                        book, "VMM Suchi," is your gateway to a blissful and fulfilling married life. Dive into a
                        treasure trove of carefully curated matrimonial profiles featuring eligible girls and boys from
                        diverse backgrounds. Let destiny unfold as you explore detailed profiles, ensuring compatibility
                        and shared values. Take the first step towards a lifetime of companionship and love with VMM
                        Suchi – where your journey to finding a suitable life partner begins!
                    </p>
                </div>
                {/* <a className="btn red_btn mt-4" data-bs-toggle="modal"
                   data-bs-target="#registrationModal">
                    Register Now
                </a> */}
            </div>
        </div>
    </div>
  </div>
</section>

        {/*  */}
        <section className="pb-0" style={{display:'none'}}>
            <div className="container">
                <div className="row">
                <div className="home-tit" data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="500">
              <p>trusted brand</p>
              <h2>
                <span>
                  Trust by <b className="num">1500</b>+ Couples
                </span>
              </h2>
              <span className="leaf1"></span>
              <span className="tit-ani-"></span>
            </div>
          </div>
          <Slider className="ourStories_slider" {...ourStories_slider} >
           <div className="hom-coup-box">
                            <span className="leaf"></span>
                            <img src={`${process.env.PUBLIC_URL}/assets/imgs/stry.png`} alt="" loading="lazy"></img>
                            <div className="bx">
                                <h4>Dany &amp; July <span>New York</span></h4>
                                <a href="wedding-video.html" className="banner_btn btn" tabIndex="-1">View more</a>
                            </div>
                        </div>
                        <div className="hom-coup-box">
                            <span className="leaf"></span>
                            <img src={`${process.env.PUBLIC_URL}/assets/imgs/stry.png`} alt="" loading="lazy"></img>
                            <div className="bx">
                                <h4>Dany &amp; July <span>New York</span></h4>
                                <a href="wedding-video.html" className="banner_btn btn" tabIndex="-1">View more</a>
                            </div>
                        </div>
                        <div className="hom-coup-box">
                            <span className="leaf"></span>
                            <img src={`${process.env.PUBLIC_URL}/assets/imgs/stry.png`} alt="" loading="lazy"></img>
                            <div className="bx">
                                <h4>Dany &amp; July <span>New York</span></h4>
                                <a href="wedding-video.html" className="banner_btn btn" tabIndex="-1">View more</a>
                            </div>
                        </div>
                        <div className="hom-coup-box">
                            <span className="leaf"></span>
                            <img src={`${process.env.PUBLIC_URL}/assets/imgs/stry.png`} alt="" loading="lazy"></img>
                            <div className="bx">
                                <h4>Dany &amp; July <span>New York</span></h4>
                                <a href="wedding-video.html" className="banner_btn btn" tabIndex="-1">View more</a>
                            </div>
                        </div>
                        <div className="hom-coup-box">
                            <span className="leaf"></span>
                            <img src={`${process.env.PUBLIC_URL}/assets/imgs/stry.png`} alt="" loading="lazy"></img>
                            <div className="bx">
                                <h4>Dany &amp; July <span>New York</span></h4>
                                <a href="wedding-video.html" className="banner_btn btn" tabIndex="-1">View more</a>
                            </div>
                        </div>
          </Slider>
        </div>
      </section>

      {/* our story */}

      <section style={{display:'none'}}>
        <div className="container">
          <div className="row">
            <div className="home-tit" data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="500">
              <p>trusted brand</p>
              <h2>
                <span>
                  Trust by <b className="num">1500</b>+ Couples
                </span>
              </h2>
              <span className="leaf1"></span>
              <span className="tit-ani-"></span>
            </div>
          </div>
          <Slider className="hom-cus-revi" {...testimonial_slider} >
            <div className="cus-revi-box">
              <div className="revi-im">
                <img src={`${process.env.PUBLIC_URL}/assets/imgs/test.png`} alt="" loading="lazy"></img>
                <i className="cir-com cir-1"></i>
                <i className="cir-com cir-2"></i>
                <i className="cir-com cir-3"></i>
              </div>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s,{" "}
              </p>
              <h5>Jack danial</h5>
              <span>New york</span>
            </div>
            <div className="cus-revi-box">
              <div className="revi-im">
                <img src={`${process.env.PUBLIC_URL}/assets/imgs/test.png`} alt="" loading="lazy"></img>
                <i className="cir-com cir-1"></i>
                <i className="cir-com cir-2"></i>
                <i className="cir-com cir-3"></i>
              </div>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s,{" "}
              </p>
              <h5>Jack danial</h5>
              <span>New york</span>
            </div>
            <div className="cus-revi-box">
              <div className="revi-im">
                <img src={`${process.env.PUBLIC_URL}/assets/imgs/test.png`} alt="" loading="lazy"></img>
                <i className="cir-com cir-1"></i>
                <i className="cir-com cir-2"></i>
                <i className="cir-com cir-3"></i>
              </div>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s,{" "}
              </p>
              <h5>Jack danial</h5>
              <span>New york</span>
            </div>
            <div className="cus-revi-box">
              <div className="revi-im">
                <img src={`${process.env.PUBLIC_URL}/assets/imgs/test.png`} alt="" loading="lazy"></img>
                <i className="cir-com cir-1"></i>
                <i className="cir-com cir-2"></i>
                <i className="cir-com cir-3"></i>
              </div>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s,{" "}
              </p>
              <h5>Jack danial</h5>
              <span>New york</span>
            </div>
            <div className="cus-revi-box">
              <div className="revi-im">
                <img src={`${process.env.PUBLIC_URL}/assets/imgs/test.png`} alt="" loading="lazy"></img>
                <i className="cir-com cir-1"></i>
                <i className="cir-com cir-2"></i>
                <i className="cir-com cir-3"></i>
              </div>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s,{" "}
              </p>
              <h5>Jack danial</h5>
              <span>New york</span>
            </div>
          </Slider>
        </div>
      </section>

      {/* our team */}

      <section className="pt-0">
        <div className="container">
          <div className="row">
            <div className="home-tit" data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="500">
              <p>OUR PROFESSIONALS</p>
              <h2>
                <span>
                  Meet Our Team
                </span>
              </h2>
              <span className="leaf1"></span>
              <span className="tit-ani-"></span>
            </div>
          </div>
         <div
  className="row"
  data-aos="fade-up"
  data-aos-easing="ease-in-out"
  data-aos-duration="1000"
>
  {loadingTeam ? (
    <div className="col-12 text-center py-4">
      <p>Loading professionals...</p>
    </div>
  ) : teamMembers.length > 0 ? (
    <>
      {teamMembers.map((member, index) => (
        <div className="col-md-3 mb-4" key={member.id || index}>
          <div className="ab-team">
            <img
              src={
                member.image_url ||
                `${process.env.PUBLIC_URL}/assets/imgs/our_team_mem.png`
              }
              alt={member.name}
              loading="lazy"
            />
            <h4>{member.name}</h4>
            <p>{member.designation}</p>
          </div>
        </div>
      ))}

      {/* View More Button */}
      <div className="col-12 text-center mt-4">
        <button
          className="btn v_m_btn px-5 py-2"
          onClick={() => navigate("/ManagementTeam")}
        >
          View More Team
        </button>
      </div>
    </>
  ) : (
    <div className="col-12 text-center py-4 text-muted">
      <p>No team configurations found.</p>
    </div>
  )}
</div>
        </div>
      </section>


      {/* bannner */}
      <section className="pt-0">
        <div className="container">
                <div className="row">
                    <div className="fot-ban-inn" data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-duration="500">
                        <div className="lhs">
                            <h2>Find your perfect Match now</h2>
                            <p>Search through verified profiles and connect with potential life partners.
Find a match who shares your values, goals, and vision for the future.</p>
                            <a className="btn" data-bs-toggle="modal"
                               data-bs-target="#registrationModal">
                                Register Now
                            </a>
                        </div>
                    </div>
                </div>
        </div>
      </section>
        <LoginModal />
        <RegistrationModal />
    </>


  );
};

export default Home;
